import React, {
  useEffect,
  useState,
  useCallback,
  useRef
} from "react";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { debounce } from "Utils/common";

type CounterProps = {
  onChange?: (value: number) => void;
  value?: number;
  maxQuantity?: number;
  resetCount?: number;
  login?: boolean;
  product: {
    shoppingQty: number
    priceStatus?: any,
    min?: number,
    max?: number,
  };
  bundle?: any;
  type?: string;
};
const Counter:React.FC<CounterProps> = (props) => {

  const { type, product, login, onChange, value, resetCount, maxQuantity } = props;
  const activeInput = useRef<{ product: typeof product; maxQuantity?: number } | null>({ product, maxQuantity });
  activeInput.current = { product, maxQuantity };
  useEffect(() => () => { activeInput.current = null; }, []);
  const [quantityV, setQuantityV] = useState<any>("1");

  const [focused, setFocused] = useState(false);
  let priceStatus = false;
  if (type !== "bundle") {
    priceStatus = !!product?.priceStatus
  }
  const orderable = (!login || priceStatus) ? false : true;

  useEffect(() => {
    if (value) {
      console.log("value", value);
      setQuantityV(value.toString());
    }
  }, [resetCount, value, maxQuantity, product])

  const addQuantity = (e: any) => {
    e.stopPropagation();
    if (!orderable) return;
    setFocused(true);
    if (!quantityV || quantityV === "0") {
      handleQty("1");
      return;
    }
    const quantity = parseInt(quantityV);
    if (type === "bundle" && product.max && quantity > product.max) return;
    if (maxQuantity != null && quantity >= maxQuantity) return;
    if (quantity === 999) {
      return;
    }
    handleQty(`${quantity + 1}`);
  };
  const subQuantity = (e: any) => {
    e.stopPropagation();
    if (!orderable) return;
    setFocused(true);
    if (!quantityV) return;
    if (quantityV === "1" || quantityV === "0") return;
    const quantity = parseInt(quantityV);
    if (quantity < 1) return;
    if ( type === "bundle" && product.min && quantity < product.min) return;
    if (quantity !== 1) {
      handleQty(`${quantity - 1}`);
    }
  };

  const handleQty = (qty: string) => {
    console.log("handleQty", qty);
    let newQty = 1;
    try {
      const num = parseInt(qty);
      // check if num is NaN
      if (Number.isNaN(num)) {
        return;
      }
      if (num < 1) {
        newQty = 1;
      } else {
        newQty = num;
      }
      if (type === "bundle") {
        console.log("product", product);
        if (product.max && newQty > product.max) {
          newQty = product.max
        }
        if (product.min && newQty < product.min) {
          newQty = product.min
        }
      }
      if (maxQuantity != null && newQty > maxQuantity) {
        newQty = maxQuantity;
      }
    } catch (error) {
      newQty = 1;
    }

    setQuantityV(newQty.toString());
    product.shoppingQty = newQty;
    if (product.shoppingQty) {
      onChange && onChange(product.shoppingQty);
    }
  };

  const debounceInputHandler = useCallback(
    debounce((val: string) => {
      console.log("debounceInputHandler", val);
      if (activeInput.current?.product !== product || activeInput.current?.maxQuantity !== maxQuantity) return;
      handleQty(val);
    }, 1000),
    [product, maxQuantity]
  );
  let editorClass = orderable
    ? `qtyEditorWrapper`
    : "qtyEditorWrapper disabled";
  editorClass = focused ? `${editorClass} focused` : editorClass;

  return (
    <div
      className={editorClass}
      onFocus={() => {
        orderable && setFocused(true);
      }}
      onBlur={() => {
        orderable && setFocused(false);
      }}
    >
      <input
        type="number"
        max={maxQuantity}
        className="qtyInput"
        disabled={!orderable}
        value={quantityV}
        onFocus={(e) => {
          orderable && setFocused(true);
        }}
        onBlur={() => {
          orderable && setFocused(false);
        }}
        onChange={(e) => {
          const inputQuantity = Number(e.target.value);
          if (maxQuantity != null && inputQuantity > maxQuantity) {
            handleQty(`${maxQuantity}`);
            return;
          }
          setQuantityV(e.target.value);
          debounceInputHandler(e.target.value);
        }}
      />
      <button
        className="plusQtyBtn"
        onClick={addQuantity}
        id="plusQty"
        disabled={!orderable || (maxQuantity != null && Number(quantityV) >= maxQuantity)}
        onBlur={() => {
          orderable && setFocused(false);
        }}
      >
        <CaretUpOutlined />
      </button>
      <button
        className="minusQtyBtn"
        onClick={subQuantity}
        disabled={!orderable}
        onBlur={() => {
          orderable && setFocused(false);
        }}
        id="minusQty"
      >
        <CaretDownOutlined />
      </button>
    </div>
  );
};

export default Counter;
